import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DecimalPipe } from '@angular/common';
import {
  NotificationsService,
  SimpleNotificationsModule
} from 'angular2-notifications';
import {
  PerfectScrollbarConfigInterface,
  PERFECT_SCROLLBAR_CONFIG
} from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { DefaultInterceptor } from './@core/helper/http.interceptor';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { AppConstants } from './constants/app.constant';
import { LayoutContainersModule } from './containers/layout/layout.containers.module';
import { ViewsModule } from './views/views.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
// import { SocketIoService } from './@services/socketIo.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20,
};

@NgModule({
  imports: [
    BrowserModule,
    ViewsModule,
    AppRoutingModule,
    LayoutContainersModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleNotificationsModule.forRoot(),
    FontAwesomeModule
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    { provide: NotificationsService },
    { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true },
    // { provide:SocketIoService},
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {provide: DecimalPipe}
  ],
})
export class AppModule {
  constructor(injector: Injector) {
    AppConstants.injector = injector;
  }
}
